export const createEasing =
  delay =>
  (...properties) =>
    properties.map(property => `${property} ${delay}ms ease-in-out`).join(',');

export const easing = createEasing(200);
